// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuickOrderTemplateDownloadedParameters extends TrackEventBaseParameters {}

const trackQuickOrderTemplateDownloaded = (
    parameters: TrackQuickOrderTemplateDownloadedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "quick_order_template_downloaded", ...parameters }, options);
};

export default trackQuickOrderTemplateDownloaded;
